module.exports = "https://cdn.hellotech.com/client-assets/computers-mobile_2e6be7b718de9d3944f88961fc9965d1.jpg";